<template>
  <div id="home">
    <section class="hero is-medium is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">
            素材をつかおう
          </h1>
          <h2 class="subtitle">
            ～無料だぞ～
          </h2>
          <div class="form">
            <search size="is-medium"></search>
          </div>
        </div>
      </div>
      <div class="bg">
        <img id="cloud01" class="cloud" :src="this.getMaterialUrl('cloud-20190509.svg')" alt="">
        <img id="cloud02" class="cloud" :src="this.getMaterialUrl('cloud-20190509.svg')" alt="">
        <img id="sun" :src="this.getMaterialUrl('sun-20190516.svg')" alt="">
        <img id="chin" class="anago" :src="this.getMaterialUrl('chin-anago-20190522.svg')" alt="">
        <img id="nikishi" class="anago" :src="this.getMaterialUrl('nishiki-anago-20190522.svg')" alt="">
      </div>
    </section>
    <main class="section">
      <div class="columns">
        <div class="column">
          <recent-material-widget limit="8" paged="1">新着素材</recent-material-widget>
          <recent-posts-widget limit="4" paged="1">ブログ</recent-posts-widget>
          <!-- <pages-widget limit="5">Pages</pages-widget> -->
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import Search from "./partials/Search.vue";
  import RecentPostsWidget from "./widgets/RecentPosts.vue";
  import RecentMaterialWidget from "./widgets/RecentMaterial.vue";
  // import PagesWidget from "./widgets/Pages.vue";
  // let base_path = process.env.VUE_APP_MATERIAL_URL_BASE;

  export default {
    data() {
      let head = this.getHeadMetaFromPost(null, "website");
      return {
        q: null,
        //seo
        title: head.title,
        link: head.link,
        meta: head.meta,
      };
    },
    head: {
      title: function () {
        return this.title
      },
      link: function () {
        return this.link
      },
      meta: function () {
        return this.meta
      },
    },
    created() {
      let post_type = this.$route.query.post_type;
      let p = this.$route.query.p;
      if (p) {
        //http://sozai.wp.nobi.server01/?post_type=material&p=2127
        // console.log(post_type, p);
        if (post_type == "material") {
          this.$router.push({
            name: 'Material',
            params: {
              postSlug: p
            }
          });
        } else {
          this.$router.push({
            name: 'Post',
            params: {
              postSlug: p
            }
          });
        }
      }
    },
    methods: {
      search() {
        // console.log(this.q);
        this.$router.push({
          name: 'Materials',
          query: {
            q: this.q
          }
        });
      }
    },
    components: {
      RecentPostsWidget,
      RecentMaterialWidget,
      Search
      // PagesWidget
    }
  };
</script>